import { render } from "./Step2Form.vue?vue&type=template&id=2f0f2641"
import script from "./Step2Form.vue?vue&type=script&lang=js"
export * from "./Step2Form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__